import { inject } from 'vue'
import { ltPaginationKey } from './constants'

export const usePagination = () => inject(ltPaginationKey, {})
